import { Component, OnInit } from '@angular/core';
import { UserData } from '../shared/interfaces/userData';
import { DataService } from '../shared/dataService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile-user',
  templateUrl: './profile-user.component.html',
  styleUrls: ['./profile-user.component.css']
})
export class ProfileUserComponent implements OnInit {
  public creds = {
    userName : "",
    newPassword : "",
    email : "",
    code : "",
    confirmPassword :""
  };
  public messageChangeUser  ="";
  public userData : UserData = 
  {
    email :"",
    userName :"",
    newPassword : "",
    confirmPassword : ""
  };
  //guardar los ateriores para saber si se modifico 
  //botón enviar
  //mandar todos los datos
  //poner botón para cambiar contraseña.


  constructor(private dataService: DataService,private router : Router) 
  { }

  onFormSubmit(event)
  {
    console.log(event);
    //ChangeDataUser
    if(this.creds.userName !=  this.userData.userName || this.creds.email != this.userData.email)
    {
      //validar los campos
      this.messageChangeUser = "Enviando solicitud.";
      this.dataService.changeDataUser(this.creds)
            .subscribe(success=>
              {
                if(success)
                {
                  //this.messageChangeUser = "Datos del usuario cambiados";
                  this.dataService.logOut();
                  this.router.navigate(['/account']);
                }
                else
                 this.messageChangeUser = "!Error al cambiar datos!";

              },error=>
              {
                this.messageChangeUser = "!Error al cambiar datos!";
                console.log(error)
              });
      console.log(this.creds);
    }
    
  }
  public getUserData()
  {
    this.dataService.GetUserData()
    .subscribe(userData=>
      {
        if(userData!= undefined)
        { 
          this.userData = userData; 
 
          this.creds.userName  = this.userData.userName; 
          this.creds.email= this.userData.email;
        }

      },error=>
      {
        console.log(error)
      });
  }
  ngOnInit() 
  {
    this.getUserData();
  }
  passwordComparison = () => {
    return this.creds.newPassword;
};
}
